import { render, staticRenderFns } from "./PrintGroupsRow.vue?vue&type=template&id=32b4fdf7&"
import script from "./PrintGroupsRow.vue?vue&type=script&lang=js&"
export * from "./PrintGroupsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports